import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

import { EventHealthApiPage, EventHealthApiResponse,ValidationApiResponse } from 'app/modules/tools-reports/event-health/event-health.types';

export interface EventHealthSearchParams {
  from?: string;
  to?: string;
  filter?: string;
  eventType?: string;
  healthStatus?: string;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root',
})
export class EventHealthService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/ctes/validation`;

  getEventHealth(search: EventHealthSearchParams): Observable<EventHealthApiPage> {
    let params = new HttpParams();

    if (search.from) {
      params = params.set('from', search.from);
    }

    if (search.to) {
      params = params.set('to', search.to);
    }

    if (search.filter) {
      params = params.set('filter', search.filter);
    }

    if (search.eventType) {
      params = params.set('eventType', search.eventType);
    }

    if (search.healthStatus) {
      params = params.set('healthStatus', search.healthStatus);
    }

    if (search.page !== undefined) {
      params = params.set('page', search.page.toString());
    }

    if (search.size !== undefined) {
      params = params.set('size', search.size.toString());
    }

    return this.http.get<EventHealthApiPage>(`${this.baseUrl}/summary`, { params });
  }

  validateEvent(urn: string): Observable<ValidationApiResponse<EventHealthApiResponse>> {
    const params = new HttpParams().set('urn', urn);

    return this.http.get<ValidationApiResponse<EventHealthApiResponse>>(`${this.baseUrl}/validate`, { params });
  }

  getEventHealthByUrn(urn: string): Observable<EventHealthApiResponse> {
    const params = new HttpParams().set('urn', urn);

    return this.http.get<EventHealthApiResponse>(`${this.baseUrl}/health`, { params });
  }
}
